var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.92,17.13v28.13c0,2.59-2.1,4.69-4.69,4.69H11.6c-2.59,0-4.69-2.1-4.69-4.69V17.13 c0-2.59,2.1-4.69,4.69-4.69h40.63C54.82,12.44,56.92,14.54,56.92,17.13z M11.6,17.13v3.98c2.19,1.78,5.68,4.56,13.14,10.4 c1.64,1.29,4.9,4.4,7.17,4.37c2.27,0.04,5.52-3.07,7.17-4.37c7.46-5.84,10.95-8.62,13.14-10.4v-3.98H11.6z M52.23,45.26V27.13 c-2.24,1.78-5.41,4.28-10.25,8.07c-2.2,1.73-5.89,5.39-10.06,5.37c-4.19,0.02-7.93-3.69-10.06-5.37 c-4.84-3.79-8.01-6.29-10.25-8.07v18.13H52.23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMailbox);
export default __webpack_public_path__ + "static/media/my_mailbox.47039633a42f1343109d612e6a6b5313.svg";
export { ForwardRef as ReactComponent };